import React from "react";

export const LoadingPage = () => {
    return (<div style={{ padding: 20 }}>Validating your credentials ...</div>);
};
